import { createContext, useContext, useState, useMemo } from "react";

const MediaContext = createContext();

function MediaProvider({ children }) {
  const [media, setMedia] = useState([]);

  const value = useMemo(() => ({ media, setMedia }), [media]);
  return (
    <MediaContext.Provider value={value}>{children}</MediaContext.Provider>
  );
}

const useMedia = () => useContext(MediaContext);

export { MediaProvider, useMedia };
